'use strict'

module.exports = { version: '8.6.1' }
